export default "/calorie/reference/@slug";
